export default ['No allergies', 'Monomer', 'Plastic', 'Metal']
